import React, { Component } from "react";
import { Div, Text, Row, Col, Image } from "atomize";
import CustomContainer from "../common/CustomContainer";
import { Anchor } from "atomize/dist";
import ImageLink from "../common/ImageLink";

class HowSlide extends Component {
  constructor(props) {
    super(props);

    this.fullSlide = React.createRef();
  }

  componentDidMount() {
    if (window.matchMedia("(min-width: 1030px)").matches) {
      this.fullSlide.current.style.width = `${this.fullSlide.current
        .offsetHeight / 0.48}px`;
    }
  }

  render() {
    const { content, ...rest } = this.props;

    return (
      <>
        <Div
          p={{
            t: { xs: "1rem", md: "3rem" },
            b: { xs: "1.5rem", md: "3rem" },
            x: "1.5rem",
          }}
        >
          <Div className="full-slide-ref" ref={this.fullSlide}>
            <Div
              bg="#131313"
              d="flex"
              flexDir={{ xs: "column", xl: "row" }}
              border="1px solid"
              borderColor="border"
            >
              <Div flexGrow="1.7">
                <Div bg="gray600" h="100%">
                  <ImageLink link="">
                    <Div
                      className="slider-image"
                      bgImg={content.image}
                      bgSize="contain"
                      bgRepeat="no-repeat"
                      bgPos="center"
                      p={{
                        b: {
                          xs: "54.5%",
                          lg: "75.5%",
                          xl: "calc(100vh - 360px)",
                        },
                      }}
                    />
                  </ImageLink>
                </Div>
              </Div>
              <Div flexGrow="1">
                <Div
                  d="flex"
                  h="100%"
                  flexDir="column"
                  justify="center"
                  p={{
                    l: { xs: "1.1rem", md: "2.25rem" },
                    r: { xs: "1.1rem", md: "2.25rem" },
                    t: { xs: "1.75rem", md: "2rem" },
                    b: { xs: "1.75rem", md: "2rem" },
                  }}
                  textAlign={{ xs: "center", sm: "left" }}
                >
                  <Text
                    textSize={{ xs: "paragraph", md: "title" }}
                    textWeight="700"
                    className="slide-title"
                    p={{ b: { xs: "0.5rem", md: "1rem" } }}
                  >
                    {content.title}
                  </Text>
                  <Text
                    textSize={{ xs: "caption2", md: "paragraph" }}
                    textColor="gray700"
                    className="slide-desc"
                  >
                    {content.desc}
                  </Text>
                  <Text
                    p={{
                      t: { xs: "1.5rem", lg: "2rem", xl: "4rem" },
                    }}
                    className="slide-link"
                  >
                    <Anchor
                      href={content.link}
                      textDecor="underline"
                      textColor="primary"
                      textWeight="700"
                      hoverTextColor="primary700"
                      style={{ fontSize: "13px", lineHeight: "16px" }}
                    >
                      {content.linkText}
                    </Anchor>
                  </Text>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </>
    );
  }
}

// const HowSlide = ({ content }) => (
//   <>
//     <Div p={{ y: { xs: "2rem", md: "3rem" }, x: "3rem" }}>
//       <Div>
//         <Div bg="#131313" d="flex">
//           <Div flexGrow="1.7">
//             <Div bg="gray600" h="100%">
//               <Div
//                 className="slider-image"
//                 bgImg={content.image}
//                 bgSize="contain"
//                 bgRepeat="no-repeat"
//                 bgPos="center"
//                 p={{ b: "calc(100vh - 350px)" }}
//               />
//             </Div>
//           </Div>
//           <Div flexGrow="1">
//             <Div
//               d="flex"
//               h="100%"
//               flexDir="column"
//               justify="center"
//               p={{
//                 l: { xs: "1rem", md: "2.25rem" },
//                 r: { xs: "1rem", md: "2.25rem" },
//                 t: { xs: "2rem" },
//                 b: { xs: "2rem" },
//               }}
//             >
//               <Text
//                 textSize="title"
//                 textWeight="700"
//                 className="slide-title"
//                 p={{
//                   b: "1rem",
//                   t: { xs: "3rem", md: "0rem" },
//                 }}
//               >
//                 {content.title}
//               </Text>
//               <Text
//                 textSize="paragraph"
//                 textColor="gray700"
//                 className="slide-desc"
//               >
//                 {content.desc}
//               </Text>
//               <Text
//                 p={{
//                   t: { xs: "3rem", lg: "2rem", xl: "4rem" },
//                 }}
//                 className="slide-link"
//               >
//                 <Anchor
//                   href={content.link}
//                   textDecor="underline"
//                   textColor="primary"
//                   hoverTextColor="primary700"
//                   style={{ fontSize: "13px", lineHeight: "16px" }}
//                 >
//                   {content.linkText}
//                 </Anchor>
//               </Text>
//             </Div>
//           </Div>
//         </Div>
//       </Div>
//     </Div>
//   </>
// );

export default HowSlide;
